export default __webpack_public_path__ + "static/17-5eb60b5b5c184eefb51e4aff680b0f10.png";